import React from 'react';
import { Link } from 'react-router-dom';
import { WHATSAPP_MESSAGE_URL } from '../constants';
import logoBlanco from '../../assets/Pastoreapp_blanco.webp';
import logoNegro from '../../assets/Pastoreappnegro.webp';

export const LandingFooter = () => {
  return (
    <footer className="bg-white dark:bg-slate-950 border-t border-slate-200 dark:border-slate-800 py-12 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
          
          {/* BRANDING */}
          <div className="md:col-span-5 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 shrink-0 overflow-hidden">
                <picture>
                  <source srcSet={logoNegro} type="image/webp" />
                  <img src={logoNegro} alt="PastoreApp" className="block dark:hidden w-full h-full object-contain" />
                </picture>
                <picture>
                  <source srcSet={logoBlanco} type="image/webp" />
                  <img src={logoBlanco} alt="PastoreApp" className="hidden dark:block w-full h-full object-contain" />
                </picture>
              </div>
              <span className="text-xl font-black bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent tracking-tighter">
                PastoreApp
              </span>
            </div>
            <p className="text-xs font-medium text-slate-500 dark:text-slate-400 leading-relaxed max-w-sm">
              Software de gestión para iglesias. Organiza personas, formación, asistencia, finanzas, liderazgo y administración ministerial en una sola plataforma.
            </p>
          </div>

          {/* NAV LINKS */}
          <div className="md:col-span-4 space-y-2">
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Navegación</p>
            <ul className="space-y-1.5 text-xs font-bold text-slate-600 dark:text-slate-400">
              <li><a href="#hero" className="hover:text-indigo-600 dark:hover:text-indigo-400">Producto</a></li>
              <li><a href="#funcionalidades" className="hover:text-indigo-600 dark:hover:text-indigo-400">Funcionalidades</a></li>
              <li><a href="#beneficios" className="hover:text-indigo-600 dark:hover:text-indigo-400">Beneficios</a></li>
              <li><a href="#como-funciona" className="hover:text-indigo-600 dark:hover:text-indigo-400">Cómo funciona</a></li>
              <li><a href="#faq" className="hover:text-indigo-600 dark:hover:text-indigo-400">Preguntas Frecuentes</a></li>
            </ul>
          </div>

          {/* ACCESS & CONTACT */}
          <div className="md:col-span-3 space-y-2">
            <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Contacto</p>
            <ul className="space-y-2 text-xs font-bold">
              <li>
                <a href={WHATSAPP_MESSAGE_URL} target="_blank" rel="noopener noreferrer" className="text-emerald-600 dark:text-emerald-400 hover:underline">
                  Solicitar demostración
                </a>
              </li>
              <li>
                <Link to="/login" className="text-indigo-600 dark:text-indigo-400 hover:underline">
                  Iniciar sesión
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-slate-100 dark:border-slate-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-slate-400 text-[11px] font-medium">
          <p>© 2026 PastoreApp. Todos los derechos reservados.</p>
          <p className="uppercase tracking-widest text-[9px] font-black">Software de Gestión para Iglesias</p>
        </div>

      </div>
    </footer>
  );
};
